import React from "react";
import { AHIcon, AHTeamIcon, Box, ColorType } from "arkh";
import { graphql, useFragment } from "react-relay";
import { HeaderPickerButton } from "./HeaderPickerButton";

type TeamPickerButtonProps = {
  onPress(): void;
  team: any;
  tintColor: ColorType;
  compact?: boolean;
};

export function TeamPickerButton(props: TeamPickerButtonProps) {
  const team = useFragment(
    graphql`
      fragment TeamPickerButton_team on Team {
        name
        icon
        isPrivate
      }
    `,
    props.team
  );

  return (
    <HeaderPickerButton
      value={team.name}
      onPress={props.onPress}
      tintColor={props.tintColor}
      isCompact={props.compact ?? false}
      icon={
        <Box style={{ flexDirection: "row", alignItems: "center" }}>
          <AHTeamIcon type={team.icon} size="small" color={props.tintColor} />
          {team.isPrivate ? (
            <AHIcon
              spaceLeft="xsmall"
              type="locked"
              size="xsmall"
              color={props.tintColor}
            />
          ) : null}
        </Box>
      }
    />
  );
}
